module.exports = __webpack_public_path__ + "static/media/gitlab-logo.4a5a5f2f.svg";